import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clientRelationshipsApi } from '../api/clientRelationshipsApi';
import { clientKeys } from './useClients';

/**
 * Mutation hook to remove (soft-delete) a client relationship.
 * Calls DELETE /api/v1/clients/:clientUserId and invalidates client queries.
 */
export function useRemoveClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (clientUserId: string) =>
      clientRelationshipsApi.removeClient(clientUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clientKeys.all });
    },
  });
}
